import React, { useRef } from 'react';
import { documents } from './Documents';

function DocumentList() {
  const categoryRefs = useRef([]);

  const scrollToCategory = (index) => {
    categoryRefs.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="documents" className="py-12 px-4 bg-gray-600">
      <h2 className="text-xl md:text-2xl font-bold text-center text-yellow-500 mb-10">
        Essential Documents for Teachers
      </h2>

      {/* Category Navigation */}
      <div className="max-w-5xl mx-auto mb-8">
        <div className="flex flex-col gap-2 justify-center">
          {documents.map((category, index) => (
            <div key={index} className="flex flex-row items-center space-x-2">
              <button
                className="w-20 px-4 py-2 bg-blue-500 text-white font-medium rounded-lg shadow hover:bg-blue-600 transition"
                onClick={() => scrollToCategory(index)}
              >
                {index + 1}
              </button>
              <button
                className="w-8/10 px-4 py-2 bg-blue-500 text-white font-medium rounded-lg shadow hover:bg-blue-600 transition"
                onClick={() => scrollToCategory(index)}
              >
                {category.name}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Document Categories and Lists */}
      <div className="max-w-5xl mx-auto">
        {documents.map((category, index) => (
          <div
            key={index}
            ref={(el) => (categoryRefs.current[index] = el)}
            className="mb-8"
          >
            <h3 className="text-lg md:text-xl font-semibold text-white mb-4">
              {`${index + 1}. ${category.name}`}
            </h3>
            <ul className="space-y-4">
              {category.items.map((doc, idx) => (
                <li
                  key={idx}
                  className="flex items-start text-gray-700 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                >
                  <span className="text-yellow-500 font-bold mr-3">•</span>
                  <div>
                    <strong className="text-lg font-medium text-gray-900">
                      {doc.name}
                    </strong>
                    <p className="text-sm md:text-base text-gray-600 mt-1">
                      {doc.usage}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default DocumentList;